import {DateField, Panes} from '@management-ui/core';
import React from 'react';
import YesNoField from '../../../../components/YesNoField';
import {saveDate} from '../../../../utilities';

const Loading = ({order = {}, prefix = ''}) => (
  <Panes
    entity={order}
    prefix={prefix}
    panes={[
      {
        title: 'Loading Details',
        fields: [
          <DateField
            name="loading_date"
            prefix={prefix}
            label="Expected Loading Date"
          />,
          <YesNoField
            name="loading_date_confirmed"
            prefix={prefix}
            label="Loading Date Confirmed"
          />
        ]
      },
      {
        title: '',
        fields: []
      }
    ]}
    title=""/>
);

Loading.onSave = ({loading_date, loading_date_confirmed}) => ({loading_date: saveDate(loading_date), loading_date_confirmed});

export default Loading;
